import {GetConfigParams} from '../shared';

export const getBaseUrl = (config: GetConfigParams, defaultBaseUrl: string): string => (config.withAbsoluteLinks ? (config.absoluteBaseUrl ? config.absoluteBaseUrl : defaultBaseUrl) : '');
